import styled from "@emotion/styled";

export const StyledCollectionPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.preview};
  min-width: 176px; // Same as Action Menu
  max-width: min(288px, 90vw); // Same as Action Menu
  border-radius: ${({ theme }) => theme.borderRadius.large};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.surface};
`;

export const StyledHeader = styled.div<{ $bgColor: string }>`
  padding: ${({ theme }) => `${theme.spacing["3"]} ${theme.spacing["4"]}`};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  background-color: ${({ $bgColor }) => $bgColor};
`;

export const StyledHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  min-width: 0;
  flex: 1;
`;

export const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  margin: 0;
  padding: 0;
  padding-top: ${({ theme }) => theme.spacing["2"]};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.large};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.large};
  border-left: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-right: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-top: none;
`;

export const StyledCardActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding: 0 ${({ theme }) => theme.spacing["4"]} ${({ theme }) => theme.spacing["3"]}
    ${({ theme }) => theme.spacing["4"]};
`;
